import { Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';

import AddMinusButton from 'components/shared/AddMinusButton';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import i18n from 'i18n';

import Divider from '../../../../../../../shared/Divider';
import { deleteFormField } from '../../../../../Page/Details/functions';
import s from './index.module.css';

const defaultFields = { firstName: true, lastName: true, email: true };

type RecipientsProps = {
  name: string;
  push: (name: string, value: any) => void;
  builder?: boolean;
  fields?: { [key: string]: boolean };
};

function Recipients({ name = 'recipients', push, fields: showFields = defaultFields, builder }: RecipientsProps) {
  return (
    <>
      <FieldArray name={name}>
        {({ fields }) =>
          fields.map((name, index) => (
            <>
              {index !== 0 && <Divider />}
              <div key={name} className={s.fields} style={{ display: fields?.value[index]?._destroy && 'none' }}>
                {showFields['firstName'] && (
                  <Field
                    className={s.field}
                    component={FormGroupAdapter}
                    name={`${name}.firstName`}
                    placeholder={
                      builder ? 'First Name' : i18n.t('common.inputs.first_name', { defaultValue: 'First Name' })
                    }
                    type="text"
                  />
                )}
                {showFields['lastName'] && (
                  <Field
                    className={s.field}
                    component={FormGroupAdapter}
                    name={`${name}.lastName`}
                    placeholder={
                      builder ? 'Last Name' : i18n.t('common.inputs.last_name', { defaultValue: 'Last Name' })
                    }
                    type="text"
                  />
                )}
                {showFields['email'] && (
                  <Field
                    className={s.field}
                    component={FormGroupAdapter}
                    name={`${name}.email`}
                    placeholder={builder ? 'Email' : i18n.t('common.inputs.email', { defaultValue: 'Email' })}
                    type="email"
                  />
                )}

                {fields.length && fields.length > 1 && (
                  <AddMinusButton variant="minus" onClick={() => deleteFormField(fields, index)} className={s.minus} />
                )}
              </div>
            </>
          ))
        }
      </FieldArray>
      <FormActions className={s.plusContainer} isCenter>
        <AddMinusButton onClick={() => push(name, undefined)} />
      </FormActions>{' '}
    </>
  );
}

export default Recipients;
